<template>
  <main class="help">
    <div class="help__container">
      <button type="button" class="help__back" @click="onBack">Назад</button>
      <h1 class="help__title">Часто задаваемые вопросы</h1>
      <v-expansion-panels class="help__units">

        <!-- Как загрузить свой прайс? -->
        <v-expansion-panel class="help__unit">
          <v-expansion-panel-header :class="['help__question']" @click="onClick">
            Как загрузить свой прайс?
          </v-expansion-panel-header>
          <v-expansion-panel-content class="help__answer">
            <p>
              Отправьте прайс в формате таблицы на нашу
              почту
              <a v-bind:href="$options.contacts.emailHref">{{ $options.contacts.emailTitle }}</a>,
              и&nbsp;мы&nbsp;самостоятельно загрузим его в&nbsp;МИС.
            </p>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <!-- Как установить мобильное приложение? -->
        <v-expansion-panel class="help__unit">
          <v-expansion-panel-header ref="pwa" :class="['help__question']" @click="onClick">
            Как установить мобильное приложение?
          </v-expansion-panel-header>
          <v-expansion-panel-content class="help__answer">
            <h2>Для Android:</h2>
            <ul>
              <li>
                Чтобы получить быстрый доступ к&nbsp;МИС 32top с&nbsp;телефона,
                следуйте инструкции. Перейдите по&nbsp;ссылке
                <a href="https://app.32top.ru/" target="_blank" rel="noopener noreferrer">
                  https://app.32top.ru/
                </a>
              </li>
              <li>Откройте дополнительные свойства браузера, нажав на&nbsp;троеточие справа;</li>
              <li>В появившемся меню найдите пункт «Добавить на&nbsp;главный экран»;</li>
              <li>Далее нажмите на&nbsp;«Установить».</li>
            </ul>
            <p>Готово! Теперь МИС 32top можно открыть сразу с&nbsp;экрана телефона!</p>
            <h2>Для IOS:</h2>
            <ul>
              <li>Нажмите на кнопку Поделиться;</li>
              <li>В открывшемся меню выберите - На экран «Домой»;</li>
              <li>Нажмите на кнопку Добавить.</li>
            </ul>
            <p>Готово! Теперь МИС 32top можно открыть сразу с&nbsp;экрана телефона!</p>
            <a
              href="https://mis-help.32top.ru/projects/mis/instructions/start_work/mob_app"
              target="_blank"
              rel="noopener noreferrer">Подробнее
            </a>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <!-- Что делать, если пациент отказывается от передачи данных в ЕГИСЗ? -->
        <v-expansion-panel class="help__unit">
          <v-expansion-panel-header :class="['help__question']" @click="onClick">
            Что делать, если пациент отказывается от передачи данных в ЕГИСЗ?
          </v-expansion-panel-header>
          <v-expansion-panel-content class="help__answer">
            <p>
              Для того, чтобы данные пациента не&nbsp;отправлялись в&nbsp;ЕГИСЗ,
              необходимо в&nbsp;разделе "Пациенты" выбрать нужного пациента
              и&nbsp;на&nbsp;вкладке "Основное" установить чек-бокс "Отказ от&nbsp;передачи
              данных в&nbsp;ЕГИСЗ", далее нажать "Сохранить".
            </p>
            <p class="info-block">
              В случае, если пациент отказывается от&nbsp;передачи данных в&nbsp;ЕГИСЗ
              ему необходимо подписать бумажную версию документа
              "Отказ от&nbsp;передачи данных в&nbsp;ЕГИСЗ".
            </p>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <!-- Где сформировать справку для налоговой? -->
        <v-expansion-panel class="help__unit">
          <v-expansion-panel-header :class="['help__question']" @click="onClick">
            Где сформировать справку для налоговой?
          </v-expansion-panel-header>
          <v-expansion-panel-content class="help__answer">
            <p>
              В левом меню перейдите в&nbsp;раздел "Пациенты", выберите нужного пациента,
              откройте вкладку "Документы". В этом разделе можно сформировать
              справку 3-НДФЛ и загрузить любые документы, требующие подписи пациента.
            </p>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <!-- Какой тип справки для налоговой выбирать: текстовый или электронный? -->
        <v-expansion-panel class="help__unit">
          <v-expansion-panel-header :class="['help__question']" @click="onClick">
            Какой тип справки для налоговой выбирать: текстовый или&nbsp;электронный?
          </v-expansion-panel-header>
          <v-expansion-panel-content class="help__answer">
            <p>
              <b>Текстовый</b> нужен для печати и передачи пациенту на&nbsp;руки бумажной
              версии справки.
            </p>
            <p>
              <b>Электронный</b> для&nbsp;отправки в&nbsp;ФНС через сервисы
              электронного документооборота.
            </p>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <!-- Как добавить перерыв сотруднику? -->
        <v-expansion-panel class="help__unit">
          <v-expansion-panel-header :class="['help__question']" @click="onClick">
            Как добавить перерыв сотруднику?
          </v-expansion-panel-header>
          <v-expansion-panel-content class="help__answer">
            <p>
              В расписании нажмите левой кнопкой мыши на&nbsp;сотрудника,
              которому необходимо добавить перерыв, в&nbsp;всплывающем
              окне выберите "Добавить&nbsp;перерыв". Укажите время
              и&nbsp;нажмите кнопку "Добавить".
            </p>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <section class="help__base-of-knowledge">
        <h1 class="help__title-section">База знаний</h1>
        <p>
          Подробные инструкции по работе с системой вы сможете найти в&nbsp;
          <a
            href="https://mis-help.32top.ru/ru/projects/mis/instructions"
            target="_blank"
            rel="noopener noreferrer">базе знаний
          </a>.
        </p>
      </section>
      <address class="support-contacts">
        <div class="support-contacts__left">
          <div class="support-contacts__caption">
            {{ $options.contacts.title }}
          </div>
          <div class="support-contacts__column">
            <a
              v-bind:href="$options.contacts.phoneHref"
              class="support-contacts__tel">
              {{ $options.contacts.phoneTitle }}
            </a>
            <a
              v-bind:href="$options.contacts.emailHref"
              class="support-contacts__email">
              {{ $options.contacts.emailTitle }}
            </a>
          </div>
        </div>
        <div class="support-contacts__right">
          <a
            class="support-contacts__button wa"
            rel="noopener noreferrer"
            target="_blank"
            v-bind:href="$options.contacts.whatsappHref">
            WhatsApp
          </a>
        </div>
      </address>
    </div>
  </main>
</template>

<script>
import widgetHDMixin from '@/mixins/widgetHDMixin';

/**
 * Данные контактов отдела поддержки
 */
const contacts = {
  title: 'Отдел поддержки',
  emailHref: 'mailto:help@32top.ru',
  emailTitle: 'help@32top.ru',
  phoneHref: 'tel:+79617210271',
  phoneTitle: '+7 (961) 721-02-71',
  whatsappHref: 'https://wa.me/79617210271/',
  telegramHref: 'https://t.me/mis_32top',
};

export default {
  async created() {
    this.appendWidgetScript();
  },
  data() {
    return {
      timerId: null,
    };
  },
  methods: {
    /**
     * @description Обработать возвращение на предыдущую страницу.
     * @returns {void}
     */
    onBack() {
      this.$router.go(-1);
    },
    /**
     * @description Обработать нажатие.
     * @param {any} event
     * @returns {void}
     */
    onClick(event) {
      clearTimeout(this.timerId);
      this.$nextTick(() => {
        this.timerId = setTimeout(() => {
          event.target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 300);
      });
    },
    /**
     * @description Показать раздел по параметрам запроса маршрута.
     * @returns {void}
     */
    showSectionByRoute() {
      if (this.$route.query.egisz) {
        clearTimeout(this.timerId);
        this.$nextTick(() => {
          this.timerId = setTimeout(() => {
            this.$refs.egisz.$el.click();
          }, 300);
        });
      }
      if (this.$route.query.pwa) {
        clearTimeout(this.timerId);
        this.$nextTick(() => {
          this.timerId = setTimeout(() => {
            this.$refs.pwa.$el.click();
          }, 300);
        });
      }
    },
  },
  name: 'ClinicPanelHelp',
  contacts,
  mixins: [
    widgetHDMixin,
  ],
  watch: {
    $route: {
      handler: 'showSectionByRoute',
      immediate: true,
    },
  },
};
</script>
<style lang="scss">
.v-expansion-panels {
  z-index: inherit !important;
}
.v-expansion-panel--active.v-item--active {
  .help__question:before {
    content: '-';
  }
}
.v-expansion-panel:not(:first-child):after {
  border-top: none !important;
}
.v-expansion-panel--active+.v-expansion-panel, .v-expansion-panel--active:not(:first-child) {
  margin-top: 0 !important;
}
.v-expansion-panel--active>.v-expansion-panel-header {
  min-height: auto !important;
}
.v-expansion-panel:before {
  box-shadow: none !important;
}
.help {
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  p {
    display: block;
    margin-bottom: 16px !important;
  }
  &__contacts {
    font-size: 18px;
    margin: 0 0 30px 0;
    a:hover {
      text-decoration: none;
    }
  }
  h2 {
    font-size: 20px;
    margin-bottom: 16px;
  }
  h3 {
    margin: 0 0 16px 0;
  }
  &__back {
    display: flex;
    align-items: center;
    gap: 7px;
    margin-bottom: 10px;
    color: var(--action-color);
    text-decoration: none;
    &:before {
      content: '';
      width: 12px;
      height: 12px;
      background-image: url('@/assets/img/arrow/arrow-blue.svg');
      background-position: center;
      background-size: contain;
    }
    &:hover {
      text-decoration: underline;
    }
  }
  &__container {
    max-width: 1187px;
    width: 100%;
    margin: 0 auto 0 0;
    padding: 38px 20px 150px 23px;
  }
  &__title {
    margin: 0 0 27px 0;
    color: #000000;
  }
  &__title-section {
    margin-bottom: 10px;
  }
  &__units {
    display: grid;
    grid-template-columns: 1fr;
    row-gap: 10px;
    margin: 27px 0 55px;
    .v-expansion-panel-header__icon {
      display: none !important;
    }
  }
  &__unit {
    .v-expansion-panel-header {
      padding: 10px 0 !important;
    }
  }
  &__question {
    display: flex;
    align-items: center;
    font-weight: 400;
    font-size: 22px;
    line-height: 29px;
    color: #192A3E;
    cursor: pointer;
    &:before {
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      opacity: 1;
      content: '+';
      background-color: #EAEFF3;
      border-radius: 50%;
      width: 20px;
      min-width: 20px;
      height: 20px;
      min-height: 20px;
      color: #707683;
      font-size: 15px;
      line-height: 20px;
      margin: 0 15px 0 0;
    }
  }
  &__answer {
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    ul {
      margin: 20px 0;
      &.list-style-dash {
        list-style-type: " — ";
      }
      &.lower-latin {
        list-style-type: lower-latin;
      }
    }
    ol {
      margin: 20px 0;
    }
    li {
      margin: 10px 0 10px 0;
    }
    .v-expansion-panel-content__wrap {
      padding: 0;
      padding-top: 20px;
    }
    h3 {
      margin: 30px 0 16px 0;
    }
    a:hover {
      text-decoration: none;
    }
    dl {
      display: inline-block;
      margin-bottom: 20px;
    }
    dt {
      display: inline;
      &::after {
        content: ' - ';
      }
    }
    dd {
      display: inline;
    }
  }
  &__img {
    display: block;
    margin: 20px 0;
    &.object-fit {
      img {
        object-fit: none;
      }
    }
  }
  &__list {
    list-style-position: inside;
    padding-left: 0 !important;
    li {
      font-weight: 600;
      ul li {
        font-weight: 400;
      }
      p {
        font-weight: 400;
        margin: 10px 0 !important;
      }
    }
  }
  &__base-of-knowledge {
    margin-bottom: 50px;
  }
}

.info-block {
  position: relative;
  display: flex;
  align-items: center;
  padding: 1rem;
  border-left: 60px solid var(--action-color);
  border-radius: .5rem;
  background-color: #e3f2fd;
  color: #0a59a4;
  &::before {
    content: 'i';
    position: absolute;
    top: 50%;
    left: -40px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    font-size: 14px;
    background-color: #e3f2fd;
    border-radius: 50%;
    transform: translateY(-50%);
  }
}

.support-contacts {
  background: #EAEFF3;
  padding: 42px 42px 50px 46px;
  display: grid;
  grid-template-columns: 1fr 333px;
  grid-gap: 50px;
  font-style: normal;
  &__left {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  &__caption {
    font-weight: 500;
    font-size: 24px;
    line-height: 29px;
    margin: 0 0 10px 0;
  }
  &__column {
    display: flex;
    flex-direction: column;
    grid-gap: 14px;
  }
  &__tel {
    font-weight: 700;
    font-size: 28px;
    line-height: 34px;
    color: #000000 !important;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
  &__email {
    color: #0489E0;
    font-weight: 400;
    font-size: 28px;
    line-height: 34px;
    &:hover {
      text-decoration: none;
    }
  }
  &__right {
    display: flex;
    flex-direction: column;
    margin: auto 0 0 0;
  }
  &__button {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 56px;
    max-width: 333px;
    width: 100%;
    border-radius: 6px;
    font-weight: 400;
    font-size: 22px;
    line-height: 26px;
    letter-spacing: 0.25px;
    color: #FFFFFF !important;
    text-decoration: none;
    &:before {
      content: '';
      width: 26px;
      min-width: 26px;
      height: 26px;
      min-height: 26px;
      background-size: contain;
      margin: 0 15px 0 0;
    }
    &.tg {
      background: #40B3E0;
      &:hover {
        background: #0489E0;
      }
      &:before {
        background-image: url("@/assets/img/social/telegram-white.svg");
      }
    }
    &.wa {
      background: #4BC389;
      &:hover {
        background: #16905a;
      }
      &:before {
        background-image: url("@/assets/img/social/whats-white.svg");
      }
    }
  }
}
@media screen and (max-width: 1060px) {
  .support-contacts {
    grid-template-columns: 1fr;
    grid-gap: 0;
    &__caption {
      margin: 0 0 20px 0;
    }
    &__right {
      padding-top: 47px;
    }
  }
}

@media screen and (max-width: 700px) {
  .help {
    &__img {
      width: 100% !important;
      height: auto !important;
      &.object-fit {
        img {
          object-fit: inherit;
        }
      }
    }
    &__container {
      padding: 45px 10px 140px;
    }
  }
}

@media screen and (max-width: 480px) {
  .help {
    &__units {
      row-gap: 5px;
    }
    &__question {
      font-size: 20px;
    }
    h2 {
      font-size: 18px;
    }
  }
  .support-contacts {
    padding: 20px 15px;
    &__tel,
    &__email {
      font-size: 24px;
    }
  }
}

</style>
